import axios from "axios";
import {
  GET_POSTDISCHARGES_COUNT,
  GET_POSTDISCHARGES_LIST,
  GET_POSTDISCHARGES_LIST_90D,
  GET_POSTDISCHARGES_LIST_180D,
  GET_POSTDISCHARGES_LIST_12M,
  GET_POSTDISCHARGES_LIST_24M,
  GET_POSTDISCHARGES_LIST_36M,
  GET_POSTDISCHARGE,
  UPDATE_POSTDISCHARGE_SAVE,
  UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE,
} from "./action-constants";

const TABLENAME_POSTDISCHARGE_COUNT = "postdischarges/count";
const TABLENAME = "postdischarges";
const TABLENAME_BY_LOGIN_ID = "postdischarges/bylogin"; /*** ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME90D = "postdischarges90d/bylogin"; /*** /bylogin added to ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME180D = "postdischarges180d/bylogin"; /*** /bylogin added to ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME12M = "postdischarges12m/bylogin"; /*** /bylogin added to ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME24M = "postdischarges24m/bylogin"; /*** /bylogin added to ROUTE UPDATED TO ADD SECURITY MEASURES */
const TABLENAME36M = "postdischarges36m/bylogin"; /*** /bylogin added to ROUTE UPDATED TO ADD SECURITY MEASURES */

export function getPostDischargesCount(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL +
    "/" +
    TABLENAME_POSTDISCHARGE_COUNT +
    "/" +
    loginID;
  return {
    type: GET_POSTDISCHARGES_COUNT,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischargesList(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL +
    "/" +
    TABLENAME_BY_LOGIN_ID +
    "/" +
    loginID;
  return {
    type: GET_POSTDISCHARGES_LIST,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarges90dList(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME90D + "/" + loginID;
  return {
    type: GET_POSTDISCHARGES_LIST_90D,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarges180dList(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME180D + "/" + loginID;
  return {
    type: GET_POSTDISCHARGES_LIST_180D,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarges12mList(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME12M + "/" + loginID;
  return {
    type: GET_POSTDISCHARGES_LIST_12M,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarges24mList(loginID) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME24M + "/" + loginID;
  return {
    type: GET_POSTDISCHARGES_LIST_24M,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarges36mList(loginID) {
  // const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + TABLENAME36M
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME36M + "/" + loginID;
  return {
    type: GET_POSTDISCHARGES_LIST_36M,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function getPostDischarge(id) {
  const JSONURL = process.env.REACT_APP_DATABASE_URL + "/POSTDISCHARGEs/" + id;
  return {
    type: GET_POSTDISCHARGE,
    payload: new Promise((resolve, reject) => {
      axios
        .get(JSONURL)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function updatePostDischargeSave(id, params) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME + "/" + id;
  return {
    type: UPDATE_POSTDISCHARGE_SAVE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(JSONURL, params)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}

export function updatePostDischargeSaveAndClose(id, params) {
  const JSONURL =
    process.env.REACT_APP_DATABASE_URL + "/" + TABLENAME + "/" + id;
  return {
    type: UPDATE_POSTDISCHARGE_SAVE_AND_CLOSE,
    payload: new Promise((resolve, reject) => {
      axios
        .put(JSONURL, params)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    }),
  };
}
